import React from "react";
import { RainFormData } from "../types";

interface Props {
  form: RainFormData;
  errors: Record<string, string>;
  onChange: (patch: Partial<RainFormData>) => void;
}

const MAX_OPTIONS = 10;

const QuestionStep: React.FC<Props> = ({ form, errors, onChange }) => {
  const setOption = (index: number, value: string) => {
    const options = [...form.options];
    options[index] = value;
    onChange({ options });
  };

  const addOption = () => {
    if (form.options.length < MAX_OPTIONS) {
      onChange({ options: [...form.options, ""] });
    }
  };

  const removeOption = (index: number) => {
    if (form.options.length > 2) {
      onChange({ options: form.options.filter((_, i) => i !== index) });
    }
  };

  return (
    <div className="rw-step">
      <h2 className="rw-step-title">What should be decided?</h2>
      <p className="rw-step-subtitle">
        Ask a clear, factual question and list the possible outcomes.
      </p>

      <label className="rw-label" htmlFor="rw-question">
        Question <span className="rw-required">*</span>
      </label>
      <textarea
        id="rw-question"
        className={`rw-input rw-textarea ${
          errors.question ? "rw-input-error" : ""
        }`}
        placeholder='e.g. "Who won the match between Team A and Team B on May 3rd?"'
        value={form.question}
        rows={3}
        onChange={(e) => onChange({ question: e.target.value })}
      />
      {errors.question && <div className="rw-error">{errors.question}</div>}

      <label className="rw-label">
        Possible outcomes <span className="rw-required">*</span>
        <span className="rw-label-hint">at least two</span>
      </label>
      {form.options.map((option, index) => (
        <div className="rw-option-row" key={index}>
          <span className="rw-option-number">{index + 1}</span>
          <input
            className={`rw-input ${
              errors[`option-${index}`] ? "rw-input-error" : ""
            }`}
            placeholder={`Outcome ${index + 1}`}
            value={option}
            onChange={(e) => setOption(index, e.target.value)}
          />
          {form.options.length > 2 && (
            <button
              type="button"
              className="rw-icon-btn"
              aria-label={`Remove outcome ${index + 1}`}
              onClick={() => removeOption(index)}
            >
              &times;
            </button>
          )}
        </div>
      ))}
      {errors.options && <div className="rw-error">{errors.options}</div>}

      {form.options.length < MAX_OPTIONS && (
        <button type="button" className="rw-add-btn" onClick={addOption}>
          + Add outcome
        </button>
      )}
    </div>
  );
};

export default QuestionStep;
